import { render } from "./QuoteCard.vue?vue&type=template&id=45180ff5&scoped=true&ts=true"
import script from "./QuoteCard.vue?vue&type=script&lang=ts"
export * from "./QuoteCard.vue?vue&type=script&lang=ts"

import "./QuoteCard.vue?vue&type=style&index=0&id=45180ff5&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45180ff5"]])

export default __exports__